export default __webpack_public_path__ + "static/media/ms.d5f65b2e.svg";